import { DiscountType } from '@masterofmalt/atom.componentlibrary/models/internal/product/IProductModel';

import { getCurrency } from '~/lib/atom/currency';
import { isVatableCountry } from '~/lib/atom/tax';
import { PriceConfig } from '~/lib/atom/types/price-config';

import { Hit } from './types/hit';

const zeroPrice = { p: { e: 0, v: 0 }, s: undefined } as const;

export const getPriceFromAlgoliaHit = ({
  currencyCode,
  prices,
  searchLookupPriceListId,
  countryCode,
  currencies,
}: PriceConfig & { prices: Hit['atom_prices'] }): {
  currentPrice: number;
  discountedFromPrice: number | null;
  discountType: DiscountType;
} => {
  const defaultTransactionalCurrency = currencies.find((c) => c.isDefault && c.isTransactional);

  if (!defaultTransactionalCurrency) {
    throw new Error('Could not find default transactional currency');
  }

  const { currency, transactionalCurrency = defaultTransactionalCurrency } = getCurrency(
    currencyCode,
    currencies,
  );

  let exchangeRate = 1;

  // If the users currency doesn't match their transactional
  // currency we need to apply exchange rate.
  if (currency.code !== transactionalCurrency.code) {
    exchangeRate = currency.exchangeRate;
  }

  const priceListPrice = prices?.[transactionalCurrency.code]?.[searchLookupPriceListId];
  const price = priceListPrice || zeroPrice;

  // v = inc VAT price
  // e = ex VAT price
  const priceKey = isVatableCountry(countryCode) ? 'v' : 'e';

  let currentPrice = price.p[priceKey];
  let discountedFromPrice = null;
  let discountType: DiscountType = 'NO_DISCOUNT';

  if (price.s) {
    currentPrice = price.s[priceKey];
    discountedFromPrice = price.p[priceKey];
    discountType = 'PREVIOUS_PRICE';
  }

  return {
    currentPrice: currentPrice * exchangeRate,
    discountedFromPrice: discountedFromPrice
      ? discountedFromPrice * exchangeRate
      : discountedFromPrice,
    discountType,
  };
};
